import React from 'react';
import PropTypes from 'prop-types';
import { formValidate } from '@eb/eds-utils';
import { Button } from '@eb/eds-button';
import { TYPE_SUBMIT, STYLE_FILL, SIZE_BLOCK } from '@eb/eds-button';
import StaticEmailField from '../StaticEmailField';

import { passwordValidate as validate } from '../utils';
import { LINKED_SOFT_ACCOUNTS_FORM } from '../../constants';

const FormSubmitButton = ({ buttonCTA, isDisabled }) => (
    <div>
        <Button
            type={TYPE_SUBMIT}
            style={STYLE_FILL}
            size={SIZE_BLOCK}
            disabled={isDisabled}
            data-automation="signup-create-password-button"
        >
            {buttonCTA}
        </Button>
    </div>
);

class LinkedSoftAccountsForm extends React.PureComponent {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        email: PropTypes.string,
        handleEmailEdit: PropTypes.func,
        onSubmit: PropTypes.func.isRequired,
        showNotification: PropTypes.func,
        clearNotification: PropTypes.func,
    };

    state = {
        isDisabled: true,
    };

    componentDidMount() {
        //eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ isDisabled: false });
    }

    // Tip: do not update the store here or you will enter a loop.
    componentWillReceiveProps({ submitting, submitFailed, error }) {
        const { showNotification, clearNotification } = this.props;

        /*If the form has an error and submit failed, attempt
        to display a notification*/
        if (submitFailed && error) {
            showNotification(error);
        }

        /*We want to limit only one error notification to
        appear per form submission if the user has dismissed it.
        So each time submitting is true, then reset the flag.*/
        if (submitting) {
            clearNotification();
        }
    }

    render() {
        const {
            clearNotification,
            clearAuthNotification,
            handleSubmit,
            email,
            handleEmailEdit,
            buttonCTA,
            submitting,
            submitSucceeded,
            socialAuthenticationData: { apple: { email: socialEmail } = {} },
        } = this.props;

        const { isDisabled } = this.state;
        const submitDisabled = isDisabled || submitting || submitSucceeded;

        const _handleClearNotification = () => {
            clearNotification && clearNotification();
            clearAuthNotification && clearAuthNotification();
        };

        return (
            <form onSubmit={handleSubmit}>
                <StaticEmailField
                    email={email || socialEmail}
                    onEmailEdit={handleEmailEdit}
                    clearNotification={_handleClearNotification}
                />
                <FormSubmitButton
                    buttonCTA={buttonCTA}
                    isDisabled={submitDisabled}
                />
            </form>
        );
    }
}

export default formValidate({
    validate,
    form: LINKED_SOFT_ACCOUNTS_FORM,
    destroyOnUnmount: false,
    touchOnBlur: false,
})(LinkedSoftAccountsForm);
